import { animate, group, query, stagger, style, transition, trigger } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
  transition('* => *', [
    style({opacity: 0}),
    animate('.6s', style({opacity: 1}))
  ])
]);

export const cardsTransitions = trigger('cardsTransitions', [
  transition('* => *',
    [
      query('.p-card-instance', [
          style({opacity: 0, transform: 'translateY(-5%)'}),
          stagger(100, [
            group([
              animate(600, style({opacity: 1})),
              animate(300, style({transform: 'translateY(0)'}))
            ])
          ])
        ], {optional: true}
      )
    ])
]);
